export const helpCenterSectionsAdapter = (data) => {
  return {
    items: data.sections
      .filter((item) => item.hidden === false && item.size > 0)
      .map((item) => ({
        id: item.id,
        caption: item.caption,
        description: item.short_description,
        slug: item.slug,
        icon: item.icon,
        size: item.size,
        key: item.size_i18n_key,
      })),
  };
};
